import {HOTB} from "../../HOTB";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/presentation/SimplePresentationRunner";
import {ExtendedGameMode} from "../../server/ExtendedGameMode";
import {TimelineLite} from "gsap";
import {ExtendedGameModel} from "../../server/ExtendedGameModel";
import {HOTBData, HOTBGameData} from "../../server/HOTBData";
import {GameUtils} from "../../utils/GameUtils";

export class TotalWinPresentation implements SimplePresentation {
    private _tl: TimelineLite;

    shouldRun(): boolean {
        const gameModel: ExtendedGameModel = HOTB.model,
            hotbData: HOTBData = gameModel.data,
            nextMode: string = hotbData.nextMode,
            gameData: HOTBGameData = gameModel.gameData,
            brokeTheBank: boolean = gameData.brokeTheBank;

        let flag: boolean = false;

        if ((gameModel.winRatio > 0 && gameModel.winRatio < 15) && !brokeTheBank && !GameUtils.isSingleWinBelowStake()) {
            if (nextMode === ExtendedGameMode.NORMAL ||
                nextMode === ExtendedGameMode.FREESPIN ||
                nextMode === ExtendedGameMode.FREESPIN_SUPER) {
                flag = true;
            }
        }

        // #268 updating winning amount in the keypad if below stake
        if ((gameModel.winRatio > 0 && gameModel.winRatio < 15) && GameUtils.isSingleWinBelowStake()) {
            HOTB.keypadPlugin.setWin(gameData.accumulatedRoundWin, true, GameUtils.isWinBelowStake());
        }

        return flag;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._tl = new TimelineLite({
            onComplete: (): void => {
                this.complete(controller);
            }
        });

        this._tl.add((): void => {
            controller.setSkipCallback(() => this.onSkip(controller));
        }, 0.001);

        const gameData: HOTBGameData = HOTB.model.gameData;
        let winAmount: number = gameData.spinRoundWin;

        this._tl.add(HOTB.totalWinView.getTotalWinTimeline(winAmount), 0);
    }

    private complete(controller: SimplePresentationRunnerController): void {
        controller.finish();
    }

    private onSkip(controller: SimplePresentationRunnerController): void {
        this._tl?.pause().kill();
        HOTB.totalWinView.hardAbort();
        this.complete(controller);
    }
}